(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fitpen-glp1-pricing"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (event) {
  var tab = event.target.closest('[data-fp-tab]');
  if (tab) {
    var root = tab.closest('.fp-glp1');
    if (!root) return;
    var id = tab.getAttribute('data-fp-tab');
    root.querySelectorAll('[data-fp-tab]').forEach(function (t) {
      var active = t.getAttribute('data-fp-tab') === id;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    root.querySelectorAll('[data-fp-panel]').forEach(function (p) {
      p.classList.toggle('is-active', p.getAttribute('data-fp-panel') === id);
    });
    return;
  }

  var cta = event.target.closest('[data-fp-cta]');
  if (cta) {
    var formId = cta.getAttribute('data-fp-form');
    if (formId) {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', formId]);
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initPromoBar(container) {
      if (!container || container.dataset.initialized === 'true') return;
      container.dataset.initialized = 'true';

      var track = container.querySelector('.robust-promo-bar-track');
      if (!track) return;

      var items = track.querySelectorAll('.robust-promo-bar-item');
      var totalItems = items.length;
      if (totalItems === 0) return;

      var speed = parseInt(container.dataset.autoplaySpeed, 10) || 3000;
      var currentIndex = 0;
      var sliderInterval = null;

      function applyMobileWidths() {
        track.style.width = (totalItems * 100) + '%';
        items.forEach(function (item) {
          item.style.width = (100 / totalItems) + '%';
        });
      }

      function clearMobileWidths() {
        track.style.width = '';
        items.forEach(function (item) {
          item.style.width = '';
        });
      }

      function startSlider() {
        if (sliderInterval) clearInterval(sliderInterval);
        applyMobileWidths();
        sliderInterval = setInterval(function () {
          currentIndex = (currentIndex + 1) % totalItems;
          var offset = -currentIndex * 100;
          track.style.transform = 'translateX(' + (offset / totalItems) + '%)';
        }, speed);
      }

      function stopSlider() {
        if (sliderInterval) clearInterval(sliderInterval);
        sliderInterval = null;
        currentIndex = 0;
        track.style.transform = 'translateX(0)';
        clearMobileWidths();
      }

      function checkDevice() {
        if (window.innerWidth <= 768 && totalItems > 1) {
          startSlider();
        } else {
          stopSlider();
        }
      }

      checkDevice();
      window.addEventListener('resize', checkDevice);

      // Shopify theme editor events: re-init when blocks change
      document.addEventListener('shopify:section:load', function (e) {
        if (e.target.contains(container)) {
          stopSlider();
          checkDevice();
        }
      });
    }

    function initAll() {
      document.querySelectorAll('.robust-promo-bar-container').forEach(initPromoBar);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    // Re-init wanneer Shopify de sectie opnieuw laadt in de theme editor
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
